import { FC, ReactNode } from 'react';
import { styled } from 'styled-components';
import WarningIcon from '@/assets/images/warning.svg?react';

interface ErrorBarProps {
	children: ReactNode;
}
const ErrorBar: FC<ErrorBarProps> = ({ children }) => {
	return (
		<Container>
			<Icon />
			<div>{children}</div>
		</Container>
	);
};

const Container = styled.nav`
	display: flex;
	gap: 1rem;
	background: #fff5fa;
	padding: 1rem;
`;

const Icon = styled(WarningIcon)`
	width: 20px;
	height: auto;
`;

export default ErrorBar;
